import { CHART_DESCRIPTION_SET } from '../../constants/chartDescriptionTypes';

export const setChartDescriptionAction = (payload) => {
  return {
    type: CHART_DESCRIPTION_SET,
    payload
  }
};
